import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FakeProducts } from '@core/fakedata/products';
import Formatter from '@core/helpers/formatter';
import { tap } from 'rxjs/operators';
import { config } from '../../../config/config';
import { AlternativeProducts } from '../../fakedata/products';
import { ApiService } from '../api/api.service';
import { SessionQuery } from './session.query';
import { SessionStore } from './session.store';

interface Credentials {
  grant_type: 'password';
  scope: '*';
  client_id: string;
  client_secret: string;
  username: string;
  password: string;
}

interface RegisterCredentials {
  grant_type: 'password';
  scope: '*';
  client_id: string;
  client_secret: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  gender: string;
  nationality_configuration_id: number;
  email: string;
  password: string;
  password_confirmation: string;
}

@Injectable({ providedIn: 'root' })
export class SessionService {
  private _refreshing: boolean = false;
  public selectedProduct = 'ING'
  public selectedAlternative = 'ABN'

  constructor(private sessionStore: SessionStore,
    private sessionQuery: SessionQuery,
    private http: HttpClient,
    private oauth: ApiService,
  ) {
  }

  public isRefreshing() {
    return this._refreshing;
  }

  getProduct() {
    return FakeProducts.find((f) => f.external_id == this.selectedProduct)
  }

  getAlternative() {
    return AlternativeProducts.find((f) => f.external_id == this.selectedAlternative)
  }

  formatPrice(x) {
    return Formatter.formatEuro(x)
  }

  login(username, password) {
    this._refreshing = false;

    const creds: Credentials = {
      grant_type: 'password',
      scope: '*',
      client_id: config.api.client_id,
      client_secret: config.api.client_secret,
      username: username,
      password: password,
    };
    return this.oauth.post('oauth/token', creds).pipe(tap(user => {
      console.log(user);
      this.sessionStore.update(user);
    }));
  }

  register(email, password, passwordRepeat, firstname, middlename, lastname, gender) {
    this._refreshing = false;

    const creds: RegisterCredentials = {
      grant_type: 'password',
      scope: '*',
      client_id: config.api.client_id,
      client_secret: config.api.client_secret,
      first_name: firstname,
      middle_name: middlename,
      last_name: lastname,
      gender: gender,
      nationality_configuration_id: 158,
      // nationality_configuration_id: 753,
      email: email,
      password: password,
      password_confirmation: passwordRepeat,
    };
    return this.oauth.post('users', creds).pipe(tap(user => {
      console.log(user);
      this.sessionStore.update(user);
    }));
  }

  logout() {
    return this.sessionStore.logout();
  }

  refresh(refresh_token: string) {
    return this.oauth.post('oauth/token', {
      'refresh_token': refresh_token,
      'grant_type': 'refresh_token',
      'client_id': config.api.client_id,
      'client_secret': config.api.client_secret,
      'scope': '*'
    }).pipe(
      tap((data) => {
        this.sessionStore.update(data);
      }),
    );
  }

}
